import { useState, useEffect } from "react";
import { useFormik } from "formik";
import {
  updateProfile,
  changePassword,
  profile,
} from "../../services/mainService";

import "./settings.css";
import { storage } from "../../utils/storage";
import {
  validateChangePassword,
  validateProfile,
} from "../../utils/validators/loginValidator";
import { Snackbar } from "../../utils/snackbar";

const Settings = () => {
  const [profilePic, setProfilePic] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const showSnackbar = (message, severity = "error") => {
    setSnackbar({ open: true, message, severity });
  };
  // Load user from storage
  const storedUser =
    typeof window !== "undefined"
      ? JSON.parse(storage.get("admin") || "{}")
      : {};

  useEffect(() => {
    fetchprofile();
    if (storedUser) {
      profileFormik.setFieldValue("fullname", storedUser.fullname || "");
      setPreview(storedUser.profile_pic || "");
    }
  }, []);

  const profileFormik = useFormik({
    initialValues: {
      fullname: "",
      email: "",
      phone_number: "",
    },
    validate: validateProfile,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const formData = {
          fullname: values.fullname,
        };

        const res = await updateProfile(formData);

        const updatedUser = {
          ...storedUser,
          fullname: res.data.fullname,
        };

        storage.set("admin", JSON.stringify(updatedUser));
        setPreview(res.data.profile_pic);
        setSnackbar({
          msg: res.message,
          severity: "success",
          open: true,
        });
      } catch (err) {
        console.error(err);
        setSnackbar({
          msg: err.response?.data?.msg || "Failed to update profile",
          severity: "error",
          open: true,
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchprofile = async () => {
    try {
      const res = await profile();
      console.log(res);
      profileFormik.setFieldValue("fullname", res.data.fullname || "");
      profileFormik.setFieldValue("email", res.data.email || "");
      profileFormik.setFieldValue("phone_number", res.data.phone_number || "");

      // setcauses(res.data);
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };

  /* ================= PASSWORD FORM ================= */

  const passwordFormik = useFormik({
    initialValues: {
      current_password: "",
      new_password: "",
      confirm_password: "",
    },
    validate: validateChangePassword,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading2(true);

        await changePassword({
          current_password: values.current_password,
          new_password: values.new_password,
        });
        setSnackbar({
          msg: "Password updated successfully",
          severity: "success",
          open: true,
        });
        resetForm();
      } catch (err) {
        setSnackbar({
          msg: "Failed to update password",
          severity: "error",
          open: true,
        });
      } finally {
        setLoading2(false);
      }
    },
  });

  return (
    <div className="settings-wrapper">
      <div className="settings-container">
        <h2 className="settings-title">Admin Settings</h2>

        <div className="settings-grid">
          {/* ================= PROFILE SECTION ================= */}
          <div className="settings-card">
            <h3>Update Profile</h3>

            <form onSubmit={profileFormik.handleSubmit}>
              <div className="profile-pic-section">
                <div className="profile-preview">
                  <span>{profileFormik.values.fullname?.charAt(0) || "A"}</span>
                </div>
              </div>

              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="fullname"
                  value={profileFormik.values.fullname}
                  onChange={profileFormik.handleChange}
                  onBlur={profileFormik.handleBlur}
                />
                {profileFormik.touched.fullname &&
                  profileFormik.errors.fullname && (
                    <span className="validation_error">
                      {profileFormik.errors.fullname}
                    </span>
                  )}
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="text"
                  name="email"
                  value={profileFormik.values.email}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="phone_number"
                  value={profileFormik.values.phone_number}
                  readOnly
                />
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? "Updating..." : "Save Changes"}
              </button>
            </form>
          </div>

          {/* ================= PASSWORD SECTION ================= */}
          <div className="settings-card">
            <h3>Change Password</h3>

            <form onSubmit={passwordFormik.handleSubmit}>
              <div className="form-group">
                <label>Current Password</label>
                <input
                  type="password"
                  name="current_password"
                  value={passwordFormik.values.current_password}
                  onChange={passwordFormik.handleChange}
                  onBlur={passwordFormik.handleBlur}
                />
                {passwordFormik.touched.current_password &&
                  passwordFormik.errors.current_password && (
                    <span className="error">
                      {passwordFormik.errors.current_password}
                    </span>
                  )}
              </div>

              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  name="new_password"
                  value={passwordFormik.values.new_password}
                  onChange={passwordFormik.handleChange}
                  onBlur={passwordFormik.handleBlur}
                />
                {passwordFormik.touched.new_password &&
                  passwordFormik.errors.new_password && (
                    <span className="error">
                      {passwordFormik.errors.new_password}
                    </span>
                  )}
              </div>

              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  name="confirm_password"
                  value={passwordFormik.values.confirm_password}
                  onChange={passwordFormik.handleChange}
                  onBlur={passwordFormik.handleBlur}
                />
                {passwordFormik.touched.confirm_password &&
                  passwordFormik.errors.confirm_password && (
                    <span className="error">
                      {passwordFormik.errors.confirm_password}
                    </span>
                  )}
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading2 ? "Updating..." : "Update Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        message={snackbar.msg}
        severity={snackbar.severity}
        onclose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </div>
  );
};

export default Settings;
